import React from 'react';
import { Card } from 'antd';
import { primaryShades, variantTokens } from '../../../theme/theme';

// Costanti dei colori
const PRIMARY = variantTokens.primary;
const PRIMARY_700 = primaryShades.primary700;
const SECONDARY = variantTokens.secondary;
const WHITE = '#ffffff';

/**
 * Componente grafico semplificato
 */
const SimpleChart = () => {
    return (
        <Card
            style={{
                borderRadius: 'clamp(0.25rem, 2vw, 0.5rem)',
                overflow: 'hidden',
                height: 'clamp(18.125rem, 30vh, 20rem)', // Convertito da 290px a rem con funzione clamp
                boxShadow: 'clamp(0rem, 0.1vw, 0rem) clamp(0.0625rem, 0.5vw, 0.125rem) clamp(0.25rem, 2vw, 0.5rem) rgba(0, 0, 0, 0.04)',
                backgroundColor: WHITE,
            }}
            styles={{ body: { padding: 'clamp(0.75rem, 3vw, 1.25rem)', height: '100%' } }}
        >
            <div style={{
                width: '100%',
                height: 'clamp(15.625rem, 28vh, 18rem)', // Convertito da 250px a rem con funzione clamp
                backgroundColor: WHITE,
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
            }}>
                {/* Titolo del grafico */}
                <div style={{
                    fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                    color: PRIMARY_700,
                    marginBottom: 'clamp(0.3125rem, 2vw, 0.625rem)',
                    fontWeight: 'bold'
                }}>
                    User Activity
                </div>

                {/* Area del grafico */}
                <div style={{
                    position: 'relative',
                    flex: 1,
                    width: '100%',
                    marginTop: 'clamp(0.3125rem, 2vw, 0.625rem)',
                }}>
                    {/* Content area with border */}
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 'clamp(0.9375rem, 3vw, 1.5625rem)', // Convertito da 25px
                        right: 'clamp(0.3125rem, 2vw, 0.625rem)', // Convertito da 10px
                        bottom: 'clamp(0.9375rem, 3vw, 1.5625rem)', // Convertito da 25px
                        borderBottom: 'clamp(0.0625rem, 0.2vw, 0.0625rem) solid #f0f0f0',
                        borderLeft: 'clamp(0.0625rem, 0.2vw, 0.0625rem) solid #f0f0f0',
                    }}>
                        {/* Grid lines */}
                        <div style={{
                            position: 'absolute',
                            width: '100%',
                            height: '25%',
                            bottom: '25%',
                            borderTop: 'clamp(0.0625rem, 0.2vw, 0.0625rem) dashed #f0f0f0',
                        }}></div>
                        <div style={{
                            position: 'absolute',
                            width: '100%',
                            height: '50%',
                            bottom: '50%',
                            borderTop: 'clamp(0.0625rem, 0.2vw, 0.0625rem) dashed #f0f0f0',
                        }}></div>
                        <div style={{
                            position: 'absolute',
                            width: '100%',
                            height: '75%',
                            bottom: '75%',
                            borderTop: 'clamp(0.0625rem, 0.2vw, 0.0625rem) dashed #f0f0f0',
                        }}></div>

                        {/* Primary area and line */}
                        <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none">
                            {/* Area under primary line */}
                            <path
                                d="M0,80 C10,75 15,70 20,70 S30,60 40,50 S50,40 60,30 S70,20 80,10 S90,17.5 100,25 L100,100 L0,100 Z"
                                fill={`${PRIMARY}20`}
                                stroke="none"
                            />
                            <path
                                d="M0,80 C10,75 15,70 20,70 S30,60 40,50 S50,40 60,30 S70,20 80,10 S90,17.5 100,25"
                                fill="none"
                                stroke={PRIMARY}
                                strokeWidth="1"
                                strokeLinejoin="round"
                                strokeLinecap="round"
                            />
                        </svg>

                        {/* Secondary area and line */}
                        <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none" style={{ position: 'absolute', top: 0, left: 0 }}>
                            {/* Area under secondary line */}
                            <path
                                d="M0,90 C10,87.5 15,86 20,85 S30,80 40,75 S50,67.5 60,60 S70,50 80,40 S90,45 100,50 L100,100 L0,100 Z"
                                fill={`${SECONDARY}20`}
                                stroke="none"
                            />
                            <path
                                d="M0,90 C10,87.5 15,86 20,85 S30,80 40,75 S50,67.5 60,60 S70,50 80,40 S90,45 100,50"
                                fill="none"
                                stroke={SECONDARY}
                                strokeWidth="1"
                                strokeLinejoin="round"
                                strokeLinecap="round"
                            />
                        </svg>

                        {/* Primary dots */}
                        <div style={{ position: 'absolute', left: '0%', bottom: '20%', width: 'clamp(0.25rem, 1vw, 0.5rem)', height: 'clamp(0.25rem, 1vw, 0.5rem)', backgroundColor: PRIMARY, borderRadius: '50%', transform: 'translate(-50%, 50%)' }}></div>
                        <div style={{ position: 'absolute', left: '20%', bottom: '30%', width: 'clamp(0.25rem, 1vw, 0.5rem)', height: 'clamp(0.25rem, 1vw, 0.5rem)', backgroundColor: PRIMARY, borderRadius: '50%', transform: 'translate(-50%, 50%)' }}></div>
                        <div style={{ position: 'absolute', left: '40%', bottom: '50%', width: 'clamp(0.25rem, 1vw, 0.5rem)', height: 'clamp(0.25rem, 1vw, 0.5rem)', backgroundColor: PRIMARY, borderRadius: '50%', transform: 'translate(-50%, 50%)' }}></div>
                        <div style={{ position: 'absolute', left: '60%', bottom: '70%', width: 'clamp(0.25rem, 1vw, 0.5rem)', height: 'clamp(0.25rem, 1vw, 0.5rem)', backgroundColor: PRIMARY, borderRadius: '50%', transform: 'translate(-50%, 50%)' }}></div>
                        <div style={{ position: 'absolute', left: '80%', bottom: '90%', width: 'clamp(0.25rem, 1vw, 0.5rem)', height: 'clamp(0.25rem, 1vw, 0.5rem)', backgroundColor: PRIMARY, borderRadius: '50%', transform: 'translate(-50%, 50%)' }}></div>
                        <div style={{ position: 'absolute', left: '100%', bottom: '75%', width: 'clamp(0.25rem, 1vw, 0.5rem)', height: 'clamp(0.25rem, 1vw, 0.5rem)', backgroundColor: PRIMARY, borderRadius: '50%', transform: 'translate(-50%, 50%)' }}></div>

                        {/* Secondary dots */}
                        <div style={{ position: 'absolute', left: '0%', bottom: '10%', width: 'clamp(0.25rem, 1vw, 0.5rem)', height: 'clamp(0.25rem, 1vw, 0.5rem)', backgroundColor: SECONDARY, borderRadius: '50%', transform: 'translate(-50%, 50%)' }}></div>
                        <div style={{ position: 'absolute', left: '20%', bottom: '15%', width: 'clamp(0.25rem, 1vw, 0.5rem)', height: 'clamp(0.25rem, 1vw, 0.5rem)', backgroundColor: SECONDARY, borderRadius: '50%', transform: 'translate(-50%, 50%)' }}></div>
                        <div style={{ position: 'absolute', left: '40%', bottom: '25%', width: 'clamp(0.25rem, 1vw, 0.5rem)', height: 'clamp(0.25rem, 1vw, 0.5rem)', backgroundColor: SECONDARY, borderRadius: '50%', transform: 'translate(-50%, 50%)' }}></div>
                        <div style={{ position: 'absolute', left: '60%', bottom: '40%', width: 'clamp(0.25rem, 1vw, 0.5rem)', height: 'clamp(0.25rem, 1vw, 0.5rem)', backgroundColor: SECONDARY, borderRadius: '50%', transform: 'translate(-50%, 50%)' }}></div>
                        <div style={{ position: 'absolute', left: '80%', bottom: '60%', width: 'clamp(0.25rem, 1vw, 0.5rem)', height: 'clamp(0.25rem, 1vw, 0.5rem)', backgroundColor: SECONDARY, borderRadius: '50%', transform: 'translate(-50%, 50%)' }}></div>
                        <div style={{ position: 'absolute', left: '100%', bottom: '50%', width: 'clamp(0.25rem, 1vw, 0.5rem)', height: 'clamp(0.25rem, 1vw, 0.5rem)', backgroundColor: SECONDARY, borderRadius: '50%', transform: 'translate(-50%, 50%)' }}></div>
                    </div>

                    {/* Y-axis labels */}
                    <div style={{ position: 'absolute', left: 0, top: '0%', fontSize: 'clamp(0.5625rem, 1.5vw, 0.625rem)', color: PRIMARY_700, transform: 'translateY(-50%)' }}>700.000</div>
                    <div style={{ position: 'absolute', left: 0, top: '33%', fontSize: 'clamp(0.5625rem, 1.5vw, 0.625rem)', color: PRIMARY_700, transform: 'translateY(-50%)' }}>500.000</div>
                    <div style={{ position: 'absolute', left: 0, top: '66%', fontSize: 'clamp(0.5625rem, 1.5vw, 0.625rem)', color: PRIMARY_700, transform: 'translateY(-50%)' }}>300.000</div>
                    <div style={{ position: 'absolute', left: 0, bottom: 0, fontSize: 'clamp(0.5625rem, 1.5vw, 0.625rem)', color: PRIMARY_700, transform: 'translateY(50%)' }}>100.000</div>

                    {/* X-axis labels */}
                    <div style={{ position: 'absolute', left: '25%', bottom: 0, fontSize: 'clamp(0.5rem, 1.4vw, 0.5625rem)', color: PRIMARY_700, transform: 'translateX(-50%) translateY(100%)' }}>2021-03-01</div>
                    <div style={{ position: 'absolute', left: '50%', bottom: 0, fontSize: 'clamp(0.5rem, 1.4vw, 0.5625rem)', color: PRIMARY_700, transform: 'translateX(-50%) translateY(100%)' }}>2021-03-12</div>
                    <div style={{ position: 'absolute', left: '75%', bottom: 0, fontSize: 'clamp(0.5rem, 1.4vw, 0.5625rem)', color: PRIMARY_700, transform: 'translateX(-50%) translateY(100%)' }}>2021-03-20</div>
                    <div style={{ position: 'absolute', right: 'clamp(0.3125rem, 2vw, 0.625rem)', bottom: 0, fontSize: 'clamp(0.5rem, 1.4vw, 0.5625rem)', color: PRIMARY_700, transform: 'translateY(100%)' }}>2021-03-31</div>
                </div>

                {/* Legend */}
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 'clamp(0.625rem, 3vw, 0.9375rem)', gap: 'clamp(0.625rem, 3vw, 0.9375rem)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 'clamp(0.3125rem, 1.5vw, 0.5rem)' }}>
                        <div style={{ width: 'clamp(0.3125rem, 1.5vw, 0.625rem)', height: 'clamp(0.3125rem, 1.5vw, 0.625rem)', backgroundColor: PRIMARY, borderRadius: '50%' }}></div>
                        <span style={{ fontSize: 'clamp(0.625rem, 1.5vw, 0.75rem)', color: PRIMARY_700 }}>Users</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 'clamp(0.3125rem, 1.5vw, 0.5rem)' }}>
                        <div style={{ width: 'clamp(0.3125rem, 1.5vw, 0.625rem)', height: 'clamp(0.3125rem, 1.5vw, 0.625rem)', backgroundColor: SECONDARY, borderRadius: '50%' }}></div>
                        <span style={{ fontSize: 'clamp(0.625rem, 1.5vw, 0.75rem)', color: PRIMARY_700 }}>Sessions</span>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default SimpleChart; 